import React, { useEffect, useState } from 'react';
import { ThinkingOrb } from 'thinking-orbs';
import EntityOrb from './EntityOrb';

const VALID_STATES = ['idle', 'inviting', 'listening', 'composing', 'thinking', 'settled', 'error'];
const VALID_SIZES = ['hero', 'compact', 'micro'];
const ENTITY_STATES = ['breathing', 'connecting', 'listening', 'working', 'searching', 'weaving', 'composing', 'solving', 'shaping'];
const ORB_STATES = {
  idle: 'breathing',
  inviting: 'connecting',
  listening: 'listening',
  composing: 'composing',
  thinking: 'working',
  settled: 'solving',
  error: 'shaping',
};

const AgentPresence = ({
  state = 'idle',
  size = 'compact',
  activity = 0,
  reducedMotion = false,
  paused = false,
}) => {
  const [entityIndex, setEntityIndex] = useState(0);
  const safeState = VALID_STATES.includes(state) ? state : 'idle';
  const safeSize = VALID_SIZES.includes(size) ? size : 'compact';
  const isHero = safeSize === 'hero';
  const safeActivity = Math.min(3, Math.max(0, Number(activity) || 0));
  const orbState = isHero ? ENTITY_STATES[entityIndex] : ORB_STATES[safeState];
  const isPaused = paused || reducedMotion || (!isHero && safeState === 'error');

  useEffect(() => {
    if (!isHero || isPaused) return;
    const interval = window.setInterval(() => {
      setEntityIndex((index) => (index + 1) % ENTITY_STATES.length);
    }, 5000);
    return () => window.clearInterval(interval);
  }, [isHero, isPaused]);

  return (
    <span
      className={`agent-presence agent-presence--${safeSize}`}
      data-state={isHero ? orbState : safeState}
      data-activity={isHero ? 0 : safeActivity}
      data-reduced-motion={reducedMotion ? 'true' : 'false'}
      data-paused={isPaused ? 'true' : 'false'}
      data-renderer="orb"
      aria-hidden="true"
    >
      {isHero ? <EntityOrb state={orbState} paused={isPaused} reducedMotion={reducedMotion} /> : <ThinkingOrb
        state={orbState}
        size={20}
        theme="dark"
        paused={isPaused}
        className="agent-presence__orb"
      />}
      {!isHero && safeState === 'error' ? <i className="bi bi-exclamation agent-presence__error" /> : null}
    </span>
  );
};

export default AgentPresence;
